exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "span.name[data-v-ebf3ba6c]{color:#0c2340}i.icon[data-v-ebf3ba6c],span.name[data-v-ebf3ba6c]{cursor:pointer}", ""]);

// exports
